import { log } from 'log';
import { htcmdService } from 'js/services/htcmd.service';
import { isProceedLoginInNative } from 'js/app/hooks/auth/helpers';

export * from 'js/hooks/auth/helpers';

export const parsePasLoginResponse = (pasLoginResponse, sessionTokenResponse = {}) => {
    const {
        userId: userIdMaybe,
        loginName: loginNameMaybe,
        username: userNameObj,
        sessionToken: { sessionToken } = {},
        sessionValidationData
    } = pasLoginResponse?.data || {};

    const userName = userNameObj?.username || userNameObj;
    const userId = userNameObj?.userId || userIdMaybe;
    const loginName = userNameObj?.loginName || loginNameMaybe;

    return {
        loginName,
        sessionToken: sessionToken || sessionTokenResponse.data?.sessionToken?.sessionToken,
        sessionValidationData,
        userId,
        userName
    };
};

export const externalLoginAction = async ({ userId, userName, sessionToken, afterRegisterLogin }) => {
    if (!sessionToken) {
        return;
    }

    if (htcmdService.isEnabled) {
        log('warn', 'NATIVE APP MODE. PREVENT LOGIN TO OPEN API');

        if (afterRegisterLogin) {
            htcmdService.registerNative({ userId, username: userName, sessionToken });
        } else {
            htcmdService.login({ userId, username: userName, sessionToken });
        }

        if (isProceedLoginInNative()) {
            return true;
        }

        return Promise.reject({ data: { isPrevented: true } });
    } else if (htcmdService.isWrapperEnabled) {
        if (afterRegisterLogin) {
            htcmdService.registerNative({ userId, username: userName });
        } else {
            htcmdService.login({ userId, username: userName });
        }

        // do not reject here and continue regular login
    }
};
